<form [formGroup]="birthForm()">
  <h2>Ange ditt födelseland och din födelseort</h2>
  <div class="form-field-group"
       [class.small-screen]="orientationService.isSmallScreen()">

    <mat-form-field
      [class.small-screen]="orientationService.isSmallScreen()">
      <mat-label>Födelseland</mat-label>
      <mat-select
        formControlName="birthCountry">
        @for (country of countryList; track $index) {
          <mat-option
            [class]="{'separator-after': $index === 0}"
            [value]="country.name">{{ country.name }}
          </mat-option>
        }
      </mat-select>

      @if (birthForm().controls.birthCountry.errors && birthForm().controls.birthCountry.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }

      <mat-error>Vänligen gör ett val</mat-error>
    </mat-form-field>

    <mat-form-field
      [class.small-screen]="orientationService.isSmallScreen()"
    >
      <mat-label>Födelseort</mat-label>
      <input placeholder="Födelseort" formControlName="birthCity" matInput type="text">
      @if (birthForm().controls.birthCity.errors && birthForm().controls.birthCity.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }

      <mat-error>Vänligen ange födelseort</mat-error>
    </mat-form-field>
  </div>

  <h2>Medborgarskap</h2>
  <p>I vilket land är du medborgare?</p>
  <div formArrayName="citizenship">
    @for (control of citizenshipControls; track $index) {
      <div class="select-country">
        <mat-form-field
          [class.small-screen]="orientationService.isSmallScreen()"
        >
          <mat-label>Välj land</mat-label>
          <mat-select [formControlName]="$index">
            @for (country of countryList; track $index) {
              <mat-option
                [class]="{'separator-after': $index === 0}"
                [value]="country.name">{{ country.name }}
              </mat-option>
            }
          </mat-select>

          @if (citizenshipControls[$index].errors && citizenshipControls[$index].touched) {
            <mat-icon matIconSuffix aria-hidden="true">
              priority_high
            </mat-icon>
          }
          @if (citizenshipControls[$index].touched) {
            <mat-error>Vänligen gör ett val</mat-error>
          }
        </mat-form-field>
        @if ($index !== 0 && $index === citizenshipControls.length - 1) {
          <button
            mat-icon-button
            (click)="removeCitizenship($index)"
            aria-label="Ta bort detta medborgarskap">
            <mat-icon class="negative">delete</mat-icon>
          </button>
        }
      </div>
    }
    <p>Om du är medborgare i fler länder, klicka på "Lägg till fler länder"
      nedan.</p>
    <button
      matButton="outlined"
      (click)="addCitizenship()"
      aria-label="Lägg till ytterligare ett medborgarskap">
      <div class="centered-container">
        <mat-icon aria-hidden="true">add</mat-icon>
        <span>Lägg till fler länder</span>
      </div>
    </button>
  </div>
</form>